<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>智能外呼列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">{{$route.meta.title}}</template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium" style="width: 100%">
            <el-form-item label="任务描述"
                          prop="title">
              <span>{{form.title}}</span>
            </el-form-item>
            <el-form-item label="客户"
                          prop="customer_id">
              <span>{{form.customer_name}}</span>
            </el-form-item>
            <el-form-item label="项目"
                          prop="project_id">
              <span>{{form.project_name}}</span>
            </el-form-item>
            <el-form-item label="外呼模板"
                          prop="robot_tpl">
              <span>{{form.robot_tpl}}</span>
            </el-form-item>
            <el-form-item label="未拨打重试次数"
                          prop="retry_times">
              <span>{{form.retry_times}}次</span>
            </el-form-item>
            <el-form-item label="未拨打重试间隔"
                          prop="retry_duration">
              <span>{{form.retry_duration}}分钟</span>
            </el-form-item>
            <el-form-item label="操作日志"
                          prop="operation_logs">
              <div v-for="(log, index) in form.operation_logs" :key="index">
                <span>{{log.created_at}}</span>
                <span>{{log.adminname}}</span>
                <span>{{log.msg}}</span>
              </div>
              <el-table :data="[form]"
                        stripe
                        highlight-current-row
                        border
                        style="width: 100%">
                <el-table-column prop="total_cnt"
                                label="总数"
                                min-width="120"></el-table-column>
                <el-table-column prop="pending_cnt"
                                label="待呼叫数"
                                min-width="120"></el-table-column>
                <el-table-column prop="closed_cnt"
                                label="不呼叫数"
                                min-width="120"></el-table-column>
                <el-table-column prop="answered_cnt"
                                label="已接通数"
                                min-width="120"></el-table-column>
                <el-table-column prop="noanswered_cnt"
                                label="未接通数"
                                min-width="120"></el-table-column>
                <el-table-column prop="failed_cnt"
                                label="失败数"
                                min-width="120"></el-table-column>
              </el-table>
            </el-form-item>
             <el-form-item label="">
              <router-link :to="`/intelligent-outbound-call/detail-table/${this.id}`">
                <el-button size="mini" type="text">外呼明细</el-button>
              </router-link>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <router-link to="/intelligent-outbound-call/table">
        <el-button>返回</el-button>
      </router-link>
    </layout-panel>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data () {
    return {
      form: {
        title: '',
        customer_id: '',
        customer_name: '',
        project_id: '',
        project_name: '',
        robot_tpl: '',
        retry_times: '',
        retry_duration: '',
        operation_logs: [],

        total_cnt: '',
        pending_cnt: '',
        noanswered_cnt: '',
        answered_cnt: '',
        closed_cnt: '',
        failed_cnt: '',
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request.page('getIntelligentOutboundCallDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
        this.form.customer_id = this.form.customer_id + ''
        this.form.project_id = this.form.project_id + ''
        this.getProjectInfoRemote().then(({data}) => {
          this.form.customer_name = `${data.name}/${data.number}`
        })
        this.getCustomerInfoRemote().then(({data}) => {
          this.form.project_name = `${data.name}/${data.number}`
        })
        this.form.retry_duration = Number(this.form.retry_duration) / 60
      })
    },
    getProjectInfoRemote () {
      return request.common('getProjectDetail', {id: this.form.project_id})
    },
    getCustomerInfoRemote () {
      return request.common('getCustomerDetail', {id: this.form.customer_id})
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/pages/IntelligentOutboundCallDetail.vue